import { ChatMessageGroup, TransformedMessage } from '@provision/chat-utils';
import { RichTextEditorFile } from '@provision/rich-text-editor';
import { createContext } from 'react';
import { useTextWithUIPrepareMetaData } from 'src/components/TextWithUI/use-text-with-ui';
import type { ConversationParticipant } from 'src/graphql/entities/conversation/conversation.types';

export enum InitialPhase {
  Idle = 'idle',
  Hydrating = 'hydrating',
  Ready = 'ready',
}

export interface ChatMessageContextValue {
  onUpdateMessage: (m: { conversationMessageId: string; body: string }) => void;
  onEditMessage?: (
    newMessage: { message: string; attachments: RichTextEditorFile[]; editedAt: string },
    originalMessage: TransformedMessage,
  ) => void;
  metaData: ReturnType<typeof useTextWithUIPrepareMetaData>['metaData'];
  messagesWithMetadata: ChatMessageGroup<ConversationParticipant>[];
  initialPhase: InitialPhase;
  isConversationLoading: boolean;
  hasMore: boolean;
  isLoadingMore: boolean;
  loadMore?: () => Promise<void>;
  reloadNewestPage?: () => Promise<string[]>;
}

export const ChatMessageContext = createContext<ChatMessageContextValue>({
  onUpdateMessage: () => undefined,
  onEditMessage: undefined,
  metaData: undefined,
  messagesWithMetadata: [],
  initialPhase: InitialPhase.Idle,
  isConversationLoading: false,
  hasMore: false,
  isLoadingMore: false,
  loadMore: undefined,
  reloadNewestPage: undefined,
});
